import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Switch } from "@/components/ui/switch"
import { Textarea } from "@/components/ui/textarea"
import { ConditionsSection } from "./conditionssection"

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  item: PlaybookItem
  vars: string[]
  onUpdate: (patch: Partial<PlaybookItem>) => void
}

export function ItemSettingsDialog({ open, onOpenChange, item, vars, onUpdate }: Props) {
  return <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="sm:max-w-xl">
      <DialogHeader>
        <DialogTitle>Item settings</DialogTitle>
      </DialogHeader>
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-2">
          <h3 className="text-sm font-medium">Intent</h3>
          <Textarea
            value={item.intent ?? ""}
            onChange={e => onUpdate({ intent: e.target.value || undefined })}
            placeholder="What this item is for, for the human author"
          />
        </div>
        {item.type !== "ai" && item.options && <label className="flex items-center justify-between gap-4">
          <div className="flex flex-col gap-1">
            <span className="text-sm font-medium">Understand free text</span>
            <span className="text-sm text-muted-foreground">When nothing matches, the model picks one of the options or none</span>
          </div>
          <Switch checked={!!item.classify} onCheckedChange={checked => onUpdate({ classify: checked || undefined })} />
        </label>}
        <ConditionsSection conditions={item.conditions ?? []} vars={vars} onChange={conditions => onUpdate({ conditions })} />
      </div>
    </DialogContent>
  </Dialog>
}
